import qs from 'qs';

export function getParams() {
  return qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });
}
